import throwError, { toastPartnerApiFailure } from "../../../comps/errorToast";
import { ContentMap } from "../../config/contentMap";
import { fieldsToAnswers, checkDuplicate } from "../../utils/api/processor";
import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import { checkCOCValidationRequired } from "../../utils/utils";
import store from "../../../store";

let g_prop;
/*********************************
 * Configuration and Common Method
 *********************************/
// UI VS Server mapping
const fieldSetupForServer = {
  dataForAccount2ndQuestionnaire: [
    "salesSupportAmericas",
    "salesSupportEurope",
    "salesSupportAfricaME",
    "salesSupportApac",
    "description",
    "alternativeLanguage",
    "descriptionOtherLanguage",
    "totalEmployees",
    "totalInsideTelephoneEmp",
    "totalOutsideDirectEmp",
    "totalTechProfOnstaff",
    "totalDevelopersOnstaff",
    "totalMktProfOnstaff",
    "custSegPrimaryFocus",
    "custSegSecondaryFocus",
    "custSegNotSignificant",
    "productExpertiseAdobe",
    "productExpertiseOther",
    "productsSoldAdobe",
    "productsSoldOther",
    "servicesPrimaryFocus",
    "servicesSecondaryFocus",
    "servicesNotSignificant",
    "verticalPrimaryFocus",
    "verticalSecondaryFocus",
    "verticalNotSignificant",
  ],
  dataForUpsertAccount: [
    "name",
    "companyPhone",
    "fax",
    "billingStreet",
    "billingCity",
    "billingState",
    "billingCountry",
    "billingPostalCode",
    "tradingName",
    "bizRegistrationNum",
    "preferredDistributor",
    "dateFounded",
    "companyType",
    "companyEmail",
    "primaryUrl",
    "secondaryUrl",
    "appearInPartnerFinder",
  ],
  dataForAccountId: "accountId",
  dataForStage1PreferredLanguage: "preferredLanguage_0",
  multiSelects: [
    "companyType",
    "salesSupportAmericas",
    "salesSupportEurope",
    "salesSupportAfricaME",
    "salesSupportApac",
    "custSegPrimaryFocus",
    "custSegSecondaryFocus",
    "custSegNotSignificant",
    "productExpertiseAdobe",
    "productsSoldAdobe",
    "servicesPrimaryFocus",
    "servicesSecondaryFocus",
    "servicesNotSignificant",
    "verticalPrimaryFocus",
    "verticalSecondaryFocus",
    "verticalNotSignificant",
  ],
};

// COMMON creation of body.
const createBody = (action) => {
  let body = {};
  fieldSetupForServer[action].forEach((field) => {
    if (field in g_prop.formStates) {
      if (typeof field == "object") {
        for (var key in field) {
          body[field[key]] = g_prop.formStates[key];
        }
      } else {
        if (fieldSetupForServer.multiSelects.includes(field)) {
          if (typeof g_prop.formStates[field] != "string") {
            body[field] = g_prop.formStates[field].join(";");
          } else {
            body[field] = g_prop.formStates[field];
          }
        } else if (field === "preferredLanguage_0") {
          body["preferredLanguage"] = g_prop.formStates[field];
        } else {
          body[field] = g_prop.formStates[field];
        }
      }
    }
  });
  return body;
};
/*********************************
 * END - Configuration and Common Method
 *********************************/

/*********************************
 * SERVER calls from buttons
 *********************************/
// Create/update Partner
export const upsertAccount = (prop) => {
  g_prop = { ...prop };
  let body;
  if (
    g_prop.btnLabel === "Submit" &&
    g_prop.formStates[fieldSetupForServer.dataForAccountId]
  ) {
    prop.is_saving(true);

    // ******* for upsert Account *******
    prop.connector.updatePartnerInfo(
      onAccountSavePending,
      {},
      g_prop.formStates[fieldSetupForServer.dataForAccountId],
      { action: "Submit" },
    );
  } else if (g_prop.formStates[fieldSetupForServer.dataForAccountId]) {
    // Update Partner on 3rd stage
    // TO BE UPDATED - use onAccountSavePending in callback

    prop.is_saving(true);
    body = createBody("dataForUpsertAccount");
    // ******* for upsert Account *******
    prop.connector.updatePartnerInfo(
      onAccountSavePending,
      { partnerInfo: body },
      g_prop.formStates[fieldSetupForServer.dataForAccountId],
    );
  }
};

export const updateQuestionnaire2 = (prop) => {
  var I18n = require("react-redux-i18n").I18n;
  g_prop = { ...prop };
  let duplicate = null;
  let dupFieldList;
  let translateMap;
  translateMap = {
    1: "AcctVerticalSegmentErrorMsg",
    2: "AcctServicesOfferedErrorMsg",
    3: "AcctCustomerSegmentErrorMsg",
  };
  dupFieldList = [
    [
      "verticalPrimaryFocus",
      "verticalSecondaryFocus",
      "verticalNotSignificant",
    ],
    [
      "servicesPrimaryFocus",
      "servicesSecondaryFocus",
      "servicesNotSignificant",
    ],
    ["custSegPrimaryFocus", "custSegSecondaryFocus", "custSegNotSignificant"],
  ];
  duplicate = checkDuplicate(g_prop.formStates, dupFieldList);
  if (duplicate) {
    throwError(I18n.t("uplevelRenewal." + translateMap[duplicate]));
  } else {
    // Update Partner on Account Questionnaire.
    // TO BE UPDATED - use onAccountSavePending in callback
    let body;
    g_prop.is_saving(true);
    body = createBody("dataForAccount2ndQuestionnaire"); // ******* for update questionnaire2 *******
    prop.connector.updatePartnerInfo(
      onAccountSavePending,
      { partnerInfo: body },
      g_prop.formStates[fieldSetupForServer.dataForAccountId],
    );
  }
};

const onAccountSavePending = (response) => {
  // if True then keep on polling
  if (response?.saveInProgress === true) {
    setTimeout(
      g_prop.connector.statusCheck,
      3000,
      onAccountSavePending,
      response?.statusUrl,
    );
    // g_prop.connector.statusCheck(onAccountSavePending,response.statusUrl);
  } else {
    onAccountSaveComplete(response);
  }
};

const onAccountSaveComplete = (response) => {
  g_prop.is_saving(false);
  if (response?.isError || Boolean(response["errorCode"])) {
    toastPartnerApiFailure(response);
  } else {
    g_prop.change("contactId_0", response?.contactId);
    g_prop.change("accountId", response?.accountId);
    if (g_prop.btnLabel === "Next" || g_prop.btnLabel === "Submit") {
      g_prop.allbuttonFunc.onNextButton();
    } else if (g_prop.btnLabel === "Save and Exit") {
      g_prop.allbuttonFunc.openChannelPartner(false);
    }
  }
};

/*********************************
 * END -SERVER calls from buttons
 *********************************/

/*********************************
 * GENERAL calls from buttons
 *********************************/

// Return from Save and Exit
export const rtrnSaveNExt = () => {
  g_prop.onClkSaveAndExit(false);
};

// rendering to Save and Exit page
export const onSaveNExt = (prop) => {
  g_prop = { ...prop };
  g_prop.allbuttonFunc.openChannelPartner(false);
  //g_prop.onClkSaveAndExit(true);
};

export const upsertContact = (prop) => {
  g_prop = { ...prop };
  let body_1 = {};
  let body_0 = {};
  if (!g_prop.formStates.contactId_1) {
    body_1 = {
      firstname: g_prop.formStates.firstName_1,
      lastName: g_prop.formStates.lastName_1,
      email: g_prop.formStates.email_1,
      phone: g_prop.formStates.phone_1,
      preferredLanguage: g_prop.formStates.preferredLanguage_1,
      jobRole: g_prop.formStates.jobRole_1,
      additionalContactType: g_prop.formStates.additionalContactType_1
        ? g_prop.formStates.additionalContactType_1.join(";")
        : "",
    };
  } else {
    body_1 = {
      phone: g_prop.formStates.phone_1,
      preferredLanguage: g_prop.formStates.preferredLanguage_1,
      jobRole: g_prop.formStates.jobRole_1,
      additionalContactType: g_prop.formStates.additionalContactType_1
        ? g_prop.formStates.additionalContactType_1.join(";")
        : "",
      mainContactType: "Secondary",
    };
  }

  body_0 = {
    phone: g_prop.formStates.phone_0,
    preferredLanguage: g_prop.formStates.preferredLanguage_0,
    jobRole: g_prop.formStates.jobRole_0,
    additionalContactType: g_prop.formStates.additionalContactType_0
      ? g_prop.formStates.additionalContactType_0.join(";")
      : "",
  };
  prop.is_saving(true);
  // ******* for Upsert Contact for updating primary and secondary contact info *******
  prop.connector.upsertPrimaryAndSecondary(
    onContactSaveComplete,
    body_0,
    g_prop.formStates.contactId_0,
    body_1,
    g_prop.formStates.contactId_1,
  );
};

const onContactSaveComplete = (response_0, response_1 = {}) => {
  g_prop.is_saving(false);

  if (response_0 && response_0?.isError) {
    toastPartnerApiFailure(response_0);
  } else {
    g_prop.change("contactId_1", response_1?.contactId);
  }

  if (response_1 && response_1?.isError) {
    toastPartnerApiFailure(response_1);
  }

  if (g_prop.btnLabel === "Next") {
    g_prop.allbuttonFunc.onNextButton();
  } else {
    g_prop.allbuttonFunc.openChannelPartner(false);
  }
};

export const updateLevel = (prop) => {
  g_prop = { ...prop };
  g_prop.is_saving(true);
  // ******* for updating the selected level *******
  g_prop.connector.updateLevel(
    onUpsertLevelComplete,
    g_prop.formStates.context.toLowerCase() === "uplevel"
      ? { level: g_prop.formStates.draftLevel }
      : {},
    g_prop.formStates.accountId,
    { context: g_prop.formStates.context },
  );
};

const onUpsertLevelComplete = (response) => {
  g_prop.is_saving(false);
  if (response?.isError || Boolean(response["errorCode"])) {
    toastPartnerApiFailure(response);
  } else {
    // Get the terms & conditions now, because the terms are not able to populate properly on the later stage due to sync issue
    // Refer - https://jira.corp.adobe.com/browse/ESSSAL-198395
    g_prop.connector.getTnC(
      onTermsAndConditionsFetchComplete,
      g_prop.formStates.draftLevel,
    );

    g_prop.formStates.prlrId = response?.prlrId;
    // g_prop.allbuttonFunc.onNextButton();
  }
};

const onTermsAndConditionsFetchComplete = (response) => {
  if (response?.isError || Boolean(response["errorCode"])) {
    toastPartnerApiFailure(response);
  } else {
    // Store the t&c in session storage to refer
    sessionStorage.setItem("term", JSON.stringify(response));

    g_prop.allbuttonFunc.onNextButton();
  }
};

export const upsertAnswers = (prop) => {
  g_prop = { ...prop };
  var answers;
  answers = fieldsToAnswers(g_prop.formStates);

  g_prop.is_saving(true);
  //****for upsert answers for questionaire 1 *****/
  g_prop.connector.updateAnswers(
    onUpsertAnswersComplete,
    { answers: answers },
    g_prop.formStates.accountId,
    { context: g_prop.formStates.context, level: g_prop.formStates.draftLevel },
  );
  //g_prop.allbuttonFunc.onNextButton();
};

const onUpsertAnswersComplete = (response) => {
  g_prop.is_saving(false);
  if (response?.isError || Boolean(response["errorCode"])) {
    toastPartnerApiFailure(response);
  } else if (response["valid"]) {
    if (g_prop.btnLabel === "Next" || g_prop.btnLabel === "Register") {
      g_prop.allbuttonFunc.onNextButton();
    } else if (g_prop.btnLabel === "Save and Exit") {
      g_prop.allbuttonFunc.openChannelPartner(false);
    }
  } else {
    toastPartnerApiFailure({});
  }
};

export const validateContacts = (prop) => {
  g_prop = { ...prop };
  if (
    store.getState().uplevelRenewal.isCOCValidateRequired ||
    (g_prop.formStates.context === "Renewal" &&
      g_prop.formStates.draftLevel === "Registered")
  ) {
    g_prop.allbuttonFunc.onNextButton();
  } else {
    g_prop.is_saving(true);
    //****for upsert answers for questionaire 1 *****/
    g_prop.connector.validateCertifiedContacts(
      validateContactsComplete,
      g_prop.formStates.accountId,
      {},
    );
  }
};

const validateContactsComplete = (response) => {
  var I18n = require("react-redux-i18n").I18n;
  g_prop.is_saving(false);
  if (response?.isError || Boolean(response["errorCode"])) {
    toastPartnerApiFailure(response);
  } else {
    if (g_prop.btnLabel === "Next") {
      if (response?.hasCertifiedContacts) g_prop.allbuttonFunc.onNextButton();
      else throwError(I18n.t("uplevelRenewal.ONBRegCerContacts"));
    } else if (g_prop.btnLabel === "Save and Exit") {
      g_prop.allbuttonFunc.openChannelPartner(false);
    }
  }
};

export const uplevelRenew = (prop) => {
  g_prop = { ...prop };
  if (
    g_prop.btnLabel === "Submit" &&
    g_prop.formStates[fieldSetupForServer.dataForAccountId]
  ) {
    prop.is_saving(true);
    // ******* for uplevel or Renew partner membership *******
    prop.connector.uplevelRenewPartner(
      uplevelRenewPartnerComplete,
      {},
      g_prop.formStates[fieldSetupForServer.dataForAccountId],
      { context: g_prop.formStates.context, action: "Submit" },
    );
  }
  //  else if(g_prop.formStates[fieldSetupForServer.dataForAccountId]) {
  //     // Update Partner on 3rd stage
  //     // TO BE UPDATED - use onAccountSavePending in callback
  //     prop.is_saving(true);
  //     body = createBody('dataForUpsertAccount');
  //     // ******* for upsert Account *******
  //     prop.connector.updatePartnerInfo(onAccountSavePending,{ "partnerInfo": body },g_prop.formStates[fieldSetupForServer.dataForAccountId]);
  // }
};

const uplevelRenewPartnerComplete = (response) => {
  g_prop.is_saving(false);
  if (response?.isError || Boolean(response["errorCode"])) {
    toastPartnerApiFailure(response);
  } else {
    g_prop.change("contactId_0", response?.contactId);
    g_prop.change("accountId", response?.accountId);
    if (g_prop.btnLabel === "Next" || g_prop.btnLabel === "Submit") {
      g_prop.allbuttonFunc.onNextButton();
    } else if (g_prop.btnLabel === "Save and Exit") {
      g_prop.allbuttonFunc.openChannelPartner(false);
    }
  }
};
